import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Button,
  Grid,
  message,
  Modal,
  Row,
} from 'antd';
import { getContenTypePorTipoDePadron } from 'api/catalogos';
import { getActCarteras, postActualizarCargos } from 'api/configuracion/actualizadorCarteras';
import ResultadoActualizacionCartera from 'components/Catalogos/ResultadoActualizadorCartera';
import { CloseCircleOutlined } from '@ant-design/icons';
import { toMoment } from '../utils/normalizers';

export const permissionConfigActionsActualizadorCartera = [
  {
    name: 'usar_actualizador_cartera_predio',
    title: 'Usar Actualizador de Cartera en padron de Predios',
    permissions: ['view_configuraciondeactualizadordecarteras', 'actualizar_cartera_predio'],
    padron: 3,
  },
  {
    name: 'usar_actualizador_cartera_empresa',
    title: 'Usar Actualizador de Cartera en padron de ComerciosFormales',
    permissions: ['view_configuraciondeactualizadordecarteras', 'actualizar_cartera_empresa'],
    padron: 2,
  },
  {
    name: 'usar_actualizador_cartera_contribuyente',
    title: 'Usar Actualizador de Cartera en padron de Contribuyentes',
    permissions: ['view_configuraciondeactualizadordecarteras', 'actualizar_cartera_contribuyente'],
    padron: 15,
  },
];

const useActualizadorDeCartera = ({
  tipoDePadronId,
  padron,
  setLoading,
  permission,
  tramite,
}) => {
  const permissionActionPadron = permissionConfigActionsActualizadorCartera
    .find((a) => a.padron === tipoDePadronId);
  const screens = Grid.useBreakpoint();
  const periodoFiscalSelected = useSelector((s) => s.auth.periodoFiscalSelected);
  const padrones = useSelector((s) => s.catalogs.padrones);
  const tipoDePadron = padrones.find((p) => p.id === tipoDePadronId);
  const [configsCarteras, setConfigsCarteras] = useState([]);
  const updateCarteraAvailable = configsCarteras.some((c) => c.estados_globales === 1)
    && tipoDePadron?.usado_en_actualizador_de_carteras
    && permission[permissionActionPadron.name];
  const showResult = (resultado, onCancel) => Modal.info({
    title: 'Resultado de actualización de cartera',
    content: <ResultadoActualizacionCartera resultado={resultado} />,
    onCancel: () => onCancel && onCancel(),
    width: screens.md ? 720 : '95%',
    closeIcon: <CloseCircleOutlined />,
    okButtonProps: { style: { display: 'none' } },
    closable: true,
    maskClosable: false,
  });

  const onClickUpdate = async (onCancel) => {
    const payload = {
      content_type_id: getContenTypePorTipoDePadron(tipoDePadronId),
      object_id: padron?.id,
      periodo_fiscal_id: periodoFiscalSelected?.id,
    };
    if (tramite) {
      payload.tramite_id = tramite.id;
      payload.aplica_desde_tramite = true;
      payload.bimestre_tramite = Math.floor(toMoment(tramite.fecha_de_creacion)?.month() / 2) + 1;
    }
    message.destroy();
    setLoading(true);
    try {
      const resultado = await postActualizarCargos(payload);
      if (resultado) showResult(resultado, onCancel);
    } finally {
      setLoading(false);
    }
  };

  const confirmUpdateCartera = (onCancel) => {
    if (!updateCarteraAvailable) return;
    message.info({
      content: (
        <>
          <br />
          <Row align="center" style={{ width: '100%' }}>
            <strong>El padrón se guardó correctamente.</strong>
          </Row>
          <Row align="center" style={{ width: '100%' }}>
            <strong>Actualizador de Carteras.</strong>
          </Row>

          <Row align="center" style={{ width: '100%' }}>
            ¿Desea actualizar la Cartera Actual de este Padron:
            {' '}
            <strong>{padron?.clave}</strong>
            ?
          </Row>
          <Row align="center" style={{ width: '100%' }}>
            (afectando cargos y accesorios)
          </Row>
          <Row align="center" style={{ width: '100%' }}>
            <Button
              type="link"
              onClick={() => onClickUpdate(onCancel)}
            >
              Si
            </Button>
            <Button
              type="link"
              onClick={() => {
                message.destroy();
                if (onCancel) onCancel();
              }}
            >
              No
            </Button>
          </Row>
        </>
      ),
      duration: 0,
    });
  };

  useEffect(() => {
    if (!tipoDePadronId) return;

    const fetchData = async () => {
      const _configsCarteras = await getActCarteras({ tipo_de_padron: tipoDePadronId });
      setConfigsCarteras(_configsCarteras);
    };
    fetchData();
  }, [tipoDePadronId]);

  return { confirmUpdateCartera, updateCarteraAvailable };
};

export default useActualizadorDeCartera;
